// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSAnchorPoint/components/ABSDot/index.less
// module id = 902
// module chunks = 42